const getStyles = () => ({
  filter: {
    filter: 'brightness(.70)'
  },
});

export default getStyles;

